<template>
    <header class="mb-4">
        <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div class="w-full md:w-96">
                <DsSearchInput
                    v-model.trim="search"
                    placeholder="Search files"
                />
            </div>

            <div class="flex items-center gap-3">
                <FileTableColumnVisibility
                    v-model="visibleFields"
                    :columns
                    :visibleColumns
                />

                <FileTableExportMenu
                    :isExportDisabled
                    @exportClipboard="$emit('exportClipboard')"
                    @exportCsv="$emit('exportCsv')"
                />
            </div>
        </div>
    </header>
</template>

<script setup lang="ts">
import type {
    FileTableColumn,
    FileTableColumnField,
    FileTableExportEmits,
} from '@/components/Views/Company/File/file-table.types';
import FileTableColumnVisibility from '@/components/Views/Company/File/FileTableColumnVisibility.vue';
import FileTableExportMenu from '@/components/Views/Company/File/FileTableExportMenu.vue';
import DsSearchInput from '@ds/form/input/DsSearchInput/DsSearchInput.vue';

defineProps<{
    columns: readonly FileTableColumn[];
    isExportDisabled: boolean;
    visibleColumns: FileTableColumn[];
}>();

const search = defineModel<string>('search', { required: true });
const visibleFields = defineModel<FileTableColumnField[]>('visibleFields', { required: true });

defineEmits<FileTableExportEmits>();
</script>
